import React from "react";
import { SketchPicker } from "react-color";
import styled from "styled-components";

const ColorPickerButton = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 11px;
  border: 2px solid #ffffff;
  box-shadow: 3px 5px 2px 0 rgba(0, 0, 0, 0.4);
  position: relative;
  cursor: pointer;
  display: block;
  background-color: ${({ color }) => (color ? color : "black")};
`;

class ButtonPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false,
    };
  }

  handleClick = () => {
    this.setState((prev) => ({
      displayColorPicker: !prev.displayColorPicker,
    }));
  };

  handleClose = () => {
    this.setState({
      displayColorPicker: false,
    });
  };

  changeColor = (color) => {
    const ind = this.props.ind;
    this.props.onColorChange(color.hex, ind);
  };

  render() {
    const popover = {
      position: 'fixed',
      top: '180px',
      left: '20px',
      zIndex: 9999,
    }

    const cover = {
      position: "fixed",
      top: "0px",
      right: "0px",
      bottom: "0px",
      left: "0px",
    };

    return (
      <section>
        <span style={{ position: "relative", display: "inline-block" }}>
          <ColorPickerButton color={this.props.color} onClick={this.handleClick} />
      
        </span>
        <section> 
        {this.state.displayColorPicker ? (
           <div style={popover}>
              <div style={cover} onClick={this.handleClose} />
              <SketchPicker
                color={this.props.color}
                onChangeComplete={this.changeColor}
              />
            </div>
          ) : null}
          </section>
        </section>
    );
  }
}

export default ButtonPicker;